export const DarkModeButtonSx = {
  position: 'absolute',
  top: 10,
  right: 37,
};